export const GET_DATA_SELECT = "GET_DATA_SELECT";
export const GET_DATA_SELECT_PENDING = `${GET_DATA_SELECT}_PENDING`;
export const GET_DATA_SELECT_FULFILLED = `${GET_DATA_SELECT}_FULFILLED`;
export const GET_DATA_SELECT_REJECTED = `${GET_DATA_SELECT}_REJECTED`;
